import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";
import {DANIEL_REINERT_PROMO_IMAGE} from "@pg-rp/consultants";

import {
    getPersonalizedHomepageConsultantPhoneHref,
    PERSONALIZED_HOMEPAGE_CONSULTANT_NAME,
    PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER
} from "../../utils/get_personalized_homepage_consultant";

const CALL_CTA_LABEL = "Zadzwoń teraz";

interface IProps {
    phoneNumber?: string;
    onConsultantClick?: (params: {ctaLabel: string; consultantName: string; phoneNumber: string}) => void;
}

/** Consultant card in the bento stack — visible on mobile and desktop per Figma. */
export const PersonalizedHomepageConsultantCard = (props: IProps) => {
    const {phoneNumber = PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER, onConsultantClick} = props;
    const headingId = useId();
    const {isMobile} = useUserDevice();

    return (
        <section className={cardStyle} aria-labelledby={headingId}>
            <header className={headStyle}>
                <Text id={headingId} as="h2" variant="headline_6" className={nameStyle}>
                    {PERSONALIZED_HOMEPAGE_CONSULTANT_NAME}
                </Text>
                <p className={statusStyle}>
                    <span className={statusDotStyle} aria-hidden="true" />
                    <Text as="span" variant="info_txt_1">
                        Doradca jest dostępny
                    </Text>
                </p>
            </header>

            <Button
                variant="outlined_secondary"
                size={isMobile ? "x-small" : "medium"}
                className={buttonStyle}
                href={getPersonalizedHomepageConsultantPhoneHref(phoneNumber)}
                iconLeft={PhoneIcon}
                title={`Zadzwoń do doradcy ${PERSONALIZED_HOMEPAGE_CONSULTANT_NAME}`}
                onClick={() => onConsultantClick?.({ctaLabel: CALL_CTA_LABEL, consultantName: PERSONALIZED_HOMEPAGE_CONSULTANT_NAME, phoneNumber})}
            >
                {CALL_CTA_LABEL}
            </Button>

            <img className={avatarStyle} src={DANIEL_REINERT_PROMO_IMAGE} alt="" aria-hidden="true" />
        </section>
    );
};

const cardStyle = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 5,
    boxSizing: "border-box",
    minHeight: "18.2rem",
    padding: 3,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    overflow: "hidden",

    md: {
        minHeight: "20.6rem"
    }
});

const headStyle = css({
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0.2rem"
});

const nameStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const statusStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    margin: 0,
    color: "var(--colors-gray-700)"
});

const statusDotStyle = css({
    width: "1rem",
    height: "1rem",
    backgroundColor: "var(--colors-green-solid)",
    borderRadius: "50%"
});

const buttonStyle = css({
    position: "relative",
    zIndex: 1,
    minWidth: "17.2rem"
});

const avatarStyle = css({
    position: "absolute",
    right: 0,
    bottom: 0,
    width: "16.1rem",
    height: "18.2rem",
    objectFit: "contain",
    objectPosition: "bottom right",

    md: {
        width: "17.9rem",
        height: "20.2rem"
    }
});
import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";
import {DANIEL_REINERT_PROMO_IMAGE} from "@pg-rp/consultants";

import {
    getPersonalizedHomepageConsultantPhoneHref,
    PERSONALIZED_HOMEPAGE_CONSULTANT_NAME,
    PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER
} from "../../utils/get_personalized_homepage_consultant";

const CALL_CTA_LABEL = "Zadzwoń teraz";

interface IProps {
    phoneNumber?: string;
    onConsultantClick?: (params: {ctaLabel: string; consultantName: string; phoneNumber: string}) => void;
}

/** Consultant card in the bento stack — visible on mobile and desktop per Figma. */
export const PersonalizedHomepageConsultantCard = (props: IProps) => {
    const {phoneNumber = PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER, onConsultantClick} = props;
    const headingId = useId();
    const {isMobile} = useUserDevice();

    return (
        <section className={cardStyle} aria-labelledby={headingId}>
            <header className={headStyle}>
                <Text id={headingId} as="h2" variant="headline_6" className={nameStyle}>
                    {PERSONALIZED_HOMEPAGE_CONSULTANT_NAME}
                </Text>
                <p className={statusStyle}>
                    <span className={statusDotStyle} aria-hidden="true" />
                    <Text as="span" variant="info_txt_1">
                        Doradca jest dostępny
                    </Text>
                </p>
            </header>

            <Button
                variant="outlined_secondary"
                size={isMobile ? "x-small" : "medium"}
                className={buttonStyle}
                href={getPersonalizedHomepageConsultantPhoneHref(phoneNumber)}
                iconLeft={PhoneIcon}
                title={`Zadzwoń do doradcy ${PERSONALIZED_HOMEPAGE_CONSULTANT_NAME}`}
                onClick={() => onConsultantClick?.({ctaLabel: CALL_CTA_LABEL, consultantName: PERSONALIZED_HOMEPAGE_CONSULTANT_NAME, phoneNumber})}
            >
                {CALL_CTA_LABEL}
            </Button>

            <img className={avatarStyle} src={DANIEL_REINERT_PROMO_IMAGE} alt="" aria-hidden="true" />
        </section>
    );
};

const cardStyle = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 5,
    boxSizing: "border-box",
    minHeight: "18.2rem",
    padding: 3,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    overflow: "hidden",

    md: {
        minHeight: "20.6rem"
    }
});

const headStyle = css({
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0.2rem"
});

const nameStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const statusStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    margin: 0,
    color: "var(--colors-gray-700)"
});

const statusDotStyle = css({
    width: "1rem",
    height: "1rem",
    backgroundColor: "var(--colors-green-solid)",
    borderRadius: "50%"
});

const buttonStyle = css({
    position: "relative",
    zIndex: 1,
    minWidth: "17.2rem"
});

const avatarStyle = css({
    position: "absolute",
    right: 0,
    bottom: 0,
    width: "16.1rem",
    height: "18.2rem",
    objectFit: "contain",
    objectPosition: "bottom right",

    md: {
        width: "17.9rem",
        height: "20.2rem"
    }
});
